module.exports = __webpack_public_path__ + "static/media/search.23160ed1.svg";